var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c(
                "div",
                {
                  staticClass: "modal-content",
                  staticStyle: { height: "calc(100vh - 50px)" },
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Select criteria: " + _vm._s(_vm.surveyName)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _vm.initialized === false
                      ? _c("h2", [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" Loading..."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.initialized
                      ? _c("div", [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group input-group-lg" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchPhrase,
                                    expression: "searchPhrase",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "search",
                                  placeholder: "Search for a criterion...",
                                },
                                domProps: { value: _vm.searchPhrase },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.searchPhrase = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm._m(1),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "list-group" },
                            _vm._l(_vm.criteriaView, function (c) {
                              return _c(
                                "button",
                                {
                                  key: c.Id,
                                  staticClass:
                                    "list-group-item list-group-item-action",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      c.IsIncluded = !c.IsIncluded
                                    },
                                  },
                                },
                                [
                                  c.IsIncluded === true
                                    ? _c("span", {
                                        staticClass:
                                          "fa-regular fa-square-check",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.IsIncluded === false
                                    ? _c("span", {
                                        staticClass: "fa-regular fa-square",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(c.Path))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.emitUpdateCriteria },
                      },
                      [_vm._v("Save & Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Close")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "alert alert-info alert-dismissible",
        attrs: { role: "alert" },
      },
      [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "alert",
              "aria-label": "Close",
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(
          "\n                            You can limit which criteria are included in your panel. To do that, simply check the criteria you want to include from the list below.\n                            "
        ),
        _c("strong", [
          _vm._v(
            "WARNING: New criteria won't be included in panels automatically."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }